import styled from 'styled-components';

const StyledVideoScrollAlone = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  overflow:hidden;
  .video--height{
    position: relative;
    padding: 0;
  }
  .video--wrap{
    position: relative;
    margin-right: 64px;
    margin-left: 64px;
  }
  .video--wrap video{
    position: relative;
    width: 100%;
  }
  @media scree and (max-width: 1439px){
    .video--wrap{
      margin-right: 40px;
      margin-left: 40px;
    }
  }
  @media screen and (max-width: 1023px){
    margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
  }
  @media screen and (max-width: 767px){
    margin-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    .video--wrap{
      margin-right: 24px;
      margin-left: 24px;
      overflow: hidden;
    }
    .video--wrap video{
      position: relative;
      height: auto
      width: 100%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

export {
  StyledVideoScrollAlone,
};

